import { Card } from '@avanta/shared/components/ui/Card';
import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

const SERVICE_ROW_WIDTHS = ['w-36', 'w-40', 'w-28'];
const PATIENT_FIELD_WIDTHS = ['w-48', 'w-28', 'w-56'];

export const AppointmentDetailSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-8" aria-hidden="true">
    <Card className="relative h-85 am-md:p-8">
      <Skeleton className="absolute top-4 right-8 h-6 w-24 rounded-full" />
      <div className="flex flex-col gap-13">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-4 w-48" />
          </div>
          <div className="flex items-center justify-between">
            <div className="flex gap-2">
              <div className="flex min-w-58 flex-col gap-3">
                <div className="mb-3 flex items-center gap-2">
                  <Skeleton className="size-4 shrink-0" />
                  <Skeleton className="h-5 w-44" />
                </div>
                {SERVICE_ROW_WIDTHS.map(width => (
                  <div key={width} className="flex items-center gap-2">
                    <Skeleton className="size-4 shrink-0" />
                    <Skeleton className={`h-5 ${width}`} />
                  </div>
                ))}
              </div>
              <div className="flex min-w-58 flex-col gap-3">
                <div className="mb-3 flex items-center gap-2">
                  <Skeleton className="size-4 shrink-0" />
                  <Skeleton className="h-5 w-16" />
                </div>
                <div className="flex gap-2">
                  <Skeleton className="size-4 shrink-0" />
                  <div className="flex flex-col gap-1">
                    <Skeleton className="h-5 w-40" />
                    <Skeleton className="h-4 w-48" />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex w-full max-w-102 shrink-0 gap-4 rounded-r-xl border-l-2 border-teal-300 bg-plum-100 px-4 py-4">
              <Skeleton className="size-24 shrink-0 rounded-full" />
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-5 w-40 max-w-full" />
                <Skeleton className="h-4 w-28 max-w-full" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-6">
          <Skeleton className="h-4 w-44" />
          <div className="flex items-center justify-end gap-3 max-am-lg:flex-col max-am-lg:items-stretch">
            <Skeleton className="h-12 w-36 rounded-full" />
            <Skeleton className="h-12 w-36 rounded-full" />
          </div>
        </div>
      </div>
    </Card>
    <Card className="am-md:px-4 am-md:py-2 am-3xl:rounded-2xl">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          {PATIENT_FIELD_WIDTHS.map(width => (
            <Skeleton key={width} className={`h-4 ${width}`} />
          ))}
        </div>
        <Skeleton className="h-10 w-40 rounded-full" />
      </div>
    </Card>
  </div>
);
